import { render, staticRenderFns } from "./ConsultarProcessoCompra.vue?vue&type=template&id=1a45285a&scoped=true"
import script from "./ConsultarProcessoCompra.vue?vue&type=script&lang=js"
export * from "./ConsultarProcessoCompra.vue?vue&type=script&lang=js"
import style0 from "./ConsultarProcessoCompra.vue?vue&type=style&index=0&id=1a45285a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a45285a",
  null
  
)

export default component.exports